import { isEmpty } from 'lodash';
import { ProductManagementFields } from 'store/productManagement/reducer.types';

export const hasProductRequiredFields = ({
  mediaType,
  channels,
  pricingMode,
  range,
  budget,
  impressions,
  frames,
  areNetworksEmpty,
}: Pick<
  ProductManagementFields,
  'mediaType' | 'channels' | 'pricingMode' | 'range' | 'budget' | 'impressions' | 'frames'
> & { areNetworksEmpty: boolean }): boolean =>
  !isEmpty(mediaType) &&
  !isEmpty(channels) &&
  !isEmpty(pricingMode) &&
  !isEmpty(range) &&
  (!isEmpty(budget) || !isEmpty(impressions) || !isEmpty(frames) || !areNetworksEmpty);
